export default class MenuToggle {
  constructor(element) {
    this.menuToggler = element;
    this.menuDialog = document.querySelector('[data-menu-dialog]');
    this.menuDialogClose = document.querySelector('[data-menu-dialog-close]');
    this.activeClass = 'is-active';
  }

  init() {
    this.menuToggler.addEventListener('click', () => {
      this.toggle();
    });
    this.menuDialogClose.addEventListener('click', () => {
      this.hide();
    });
    this.onKeyDown = this.onKeyDown.bind(this);
    return this;
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.menuDialogClose.click();
    }
  }

  toggle() {
    if (this.menuDialog.classList.contains(this.activeClass)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    window.addEventListener('keydown', this.onKeyDown);
    document.documentElement.style.overflow = 'hidden';
    this.menuDialog.classList.add(this.activeClass);
    this.menuDialog.showModal();
  }

  hide() {
    window.removeEventListener('keydown', this.onKeyDown);
    document.documentElement.style.overflow = '';
    this.menuDialog.classList.remove(this.activeClass);
    this.menuDialog.close();
  }
}
